import React, { Component } from "react";
import { connect } from "react-redux";
import { userActions } from "../../_actions";
import { AdminMessage } from "../../_components";
import { userConstants } from "../../_constants";
import "../../assets/css/mainAdmin.css";
import EDUDark from "../../assets/images/EDU-dark.png";
import EDU from "../../assets/images/EDU.png";
import eventDark from "../../assets/images/event-dark.png";
import event from "../../assets/images/event.png";
import hbdDark from "../../assets/images/hbd-dark.png";
import hbd from "../../assets/images/hbd.png";
import hospitalDark from "../../assets/images/hospital-dark.png";
import hospital from "../../assets/images/hospital.png";
import linkDark from "../../assets/images/link-dark.png";
import link from "../../assets/images/link.png";
import newsDark from "../../assets/images/news-dark.png";
import news from "../../assets/images/news.png";
import telephoneDark from "../../assets/images/telephone-dark.png";
import telephone from "../../assets/images/telephone.png";
import { BtnRound } from "../../_components/BtnRound";
import { EduAdmin } from "./EduAdmin";
import { Events } from "./Events";
import { GeneralInfo } from "./GeneralInfo";
import { HappyBirthday } from "./HappyBirthday";
import { NewsAdmin } from "./NewsAdmin";
import { TelCenter } from "./TelCenter";
import { Tools } from "./Tools";

class MainAdmin_ extends Component {
  constructor(props) {
    super(props);
    this.state = {
      currentPage: null,
      BtnList: [
        {
          img: EDUDark,
          text: "آموزش",
          onClick: (i) => this.setState({ currentPage: i }),
        },
        {
          img: newsDark,
          text: "اخبار",
          onClick: (i) => this.setState({ currentPage: i }),
        },
        {
          img: eventDark,
          text: "رویداد ها",
          onClick: (i) => this.setState({ currentPage: i }),
        },
        {
          img: linkDark,
          text: "نرم افزار های کاربردی",
          onClick: (i) => this.setState({ currentPage: i }),
        },
        {
          img: telephoneDark,
          text: "تلفن خانه",
          onClick: (i) => this.setState({ currentPage: i }),
        },
        {
          img: hospitalDark,
          text: "اطلاعات کلی",
          onClick: (i) => this.setState({ currentPage: i }),
        },
        {
          img: hbdDark,
          text: "تولد ها",
          onClick: (i) => this.setState({ currentPage: i }),
        },
      ],
      hospitalInfo: {},
    };
    this.hospital_id = localStorage.getItem("hospital_id");
  }

  componentDidMount = () => {
    if (!localStorage.getItem("tokenAdmin")) {
      userActions.failure("کاربر گرامی ابتدا باید به حساب خود وارد شوید.");
      this.props.history.push(`/loginAdmin`);
    }
    this.getHospitals();
    document.querySelector(".wave").classList.add("hidden");
  };

  componentDidUpdate = (props, state) => {
    const { onWarning } = this;
    const { currentPage, hospitalInfo } = this.state;
    const { activate_portal, activate_azmoon } = hospitalInfo;
    if (state.currentPage !== currentPage) {
      if (!activate_portal) {
        this.setState({
          BtnList: [
            {
              img: currentPage === 0 ? EDU : EDUDark,
              text: "آموزش",
              onClick: (i) => this.setState({ currentPage: i }),
            },
            {
              img: newsDark,
              text: "اخبار",
              onClick: onWarning,
            },
            {
              img: eventDark,
              text: "رویداد ها",
              onClick: onWarning,
            },
            {
              img: linkDark,
              text: "نرم افزار های کاربردی",
              onClick: onWarning,
            },
            {
              img: telephoneDark,
              text: "تلفن خانه",
              onClick: onWarning,
            },
            {
              img: hospitalDark,
              text: "اطلاعات کلی",
              onClick: onWarning,
            },
            {
              img: hbdDark,
              text: "تولد ها",
              onClick: onWarning,
            },
          ],
        });
      }
      if (!activate_azmoon) {
        this.setState({
          BtnList: [
            {
              img: EDUDark,
              text: "آموزش",
              onClick: onWarning,
            },
            {
              img: currentPage === 1 ? news : newsDark,
              text: "اخبار",
              onClick: (i) => this.setState({ currentPage: i }),
            },
            {
              img: currentPage === 2 ? event : eventDark,
              text: "رویداد ها",
              onClick: (i) => this.setState({ currentPage: i }),
            },
            {
              img: currentPage === 3 ? link : linkDark,
              text: "نرم افزار های کاربردی",
              onClick: (i) => this.setState({ currentPage: i }),
            },
            {
              img: currentPage === 4 ? telephone : telephoneDark,
              text: "تلفن خانه",
              onClick: (i) => this.setState({ currentPage: i }),
            },
            {
              img: currentPage === 5 ? hospital : hospitalDark,
              text: "اطلاعات کلی",
              onClick: (i) => this.setState({ currentPage: i }),
            },
            {
              img: currentPage === 6 ? hbd : hbdDark,
              text: "تولد ها",
              onClick: (i) => this.setState({ currentPage: i }),
            },
          ],
        });
      }
      if (activate_portal && activate_azmoon) {
        this.setState({
          BtnList: [
            {
              img: currentPage === 0 ? EDU : EDUDark,
              text: "آموزش",
              onClick: (i) => this.setState({ currentPage: i }),
            },
            {
              img: currentPage === 1 ? news : newsDark,
              text: "اخبار",
              onClick: (i) => this.setState({ currentPage: i }),
            },
            {
              img: currentPage === 2 ? event : eventDark,
              text: "رویداد ها",
              onClick: (i) => this.setState({ currentPage: i }),
            },
            {
              img: currentPage === 3 ? link : linkDark,
              text: "نرم افزار های کاربردی",
              onClick: (i) => this.setState({ currentPage: i }),
            },
            {
              img: currentPage === 4 ? telephone : telephoneDark,
              text: "تلفن خانه",
              onClick: (i) => this.setState({ currentPage: i }),
            },
            {
              img: currentPage === 5 ? hospital : hospitalDark,
              text: "اطلاعات کلی",
              onClick: (i) => this.setState({ currentPage: i }),
            },
            {
              img: currentPage === 6 ? hbd : hbdDark,
              text: "تولد ها",
              onClick: (i) => this.setState({ currentPage: i }),
            },
          ],
        });
      }
    }
  };

  componentWillUnmount = () => {
    document.querySelector(".wave").classList.remove("hidden");
  };

  handleLogout = () => {
    this.props
      .dispatch(userActions.question("خروج", "آیا از خروج مطمئن هستید؟"))
      .then((r) => {
        if (r.value) {
          localStorage.removeItem("tokenAdmin");
          localStorage.removeItem("hospital_id");
          this.props.history.push("/loginAdmin");
        }
      });
  };

  onWarning = () => {
    userActions.warningWithSubmit2(
      "مدیر گرامی",
      "امکان استفاده از این ماژول برای شما فعال نمی باشد. در صورت نیاز با ما تماس بگیرید: 09354192487",
      "متوجه شدم"
    );
  };

  disablePortalBtns = () => {
    const { onWarning } = this;

    this.setState({
      BtnList: [
        {
          img: EDUDark,
          text: "آموزش",
          onClick: (i) => this.setState({ currentPage: i }),
        },
        {
          img: newsDark,
          text: "اخبار",
          onClick: onWarning,
        },
        {
          img: eventDark,
          text: "رویداد ها",
          onClick: onWarning,
        },
        {
          img: linkDark,
          text: "نرم افزار های کاربردی",
          onClick: onWarning,
        },
        {
          img: telephoneDark,
          text: "تلفن خانه",
          onClick: onWarning,
        },
        {
          img: hospitalDark,
          text: "اطلاعات کلی",
          onClick: onWarning,
        },
        {
          img: hbdDark,
          text: "تولد ها",
          onClick: onWarning,
        },
      ],
    });
  };

  disableAzmoonBtns = () => {
    const { onWarning } = this;

    this.setState({
      BtnList: [
        {
          img: EDUDark,
          text: "آموزش",
          onClick: onWarning,
        },
        {
          img: newsDark,
          text: "اخبار",
          onClick: (i) => this.setState({ currentPage: i }),
        },
        {
          img: eventDark,
          text: "رویداد ها",
          onClick: (i) => this.setState({ currentPage: i }),
        },
        {
          img: linkDark,
          text: "نرم افزار های کاربردی",
          onClick: (i) => this.setState({ currentPage: i }),
        },
        {
          img: telephoneDark,
          text: "تلفن خانه",
          onClick: (i) => this.setState({ currentPage: i }),
        },
        {
          img: hospitalDark,
          text: "اطلاعات کلی",
          onClick: (i) => this.setState({ currentPage: i }),
        },
        {
          img: hbdDark,
          text: "تولد ها",
          onClick: (i) => this.setState({ currentPage: i }),
        },
      ],
    });
  };

  disableAzmoonAndPortalBtns = () => {
    const { onWarning } = this;

    this.setState({
      BtnList: [
        {
          img: EDUDark,
          text: "آموزش",
          onClick: onWarning,
        },
        {
          img: newsDark,
          text: "اخبار",
          onClick: onWarning,
        },
        {
          img: eventDark,
          text: "رویداد ها",
          onClick: onWarning,
        },
        {
          img: linkDark,
          text: "نرم افزار های کاربردی",
          onClick: onWarning,
        },
        {
          img: telephoneDark,
          text: "تلفن خانه",
          onClick: onWarning,
        },
        {
          img: hospitalDark,
          text: "اطلاعات کلی",
          onClick: onWarning,
        },
        {
          img: hbdDark,
          text: "تولد ها",
          onClick: onWarning,
        },
      ],
    });
  };

  getHospitals = () => {
    const { disablePortalBtns, disableAzmoonBtns, disableAzmoonAndPortalBtns } =
      this;
    this.props
      .dispatch(userActions.API("get", `v1/hospitals`, null, true))
      .then((res) => {
        const currentHospital = res.data.find(
          ({ id }) => id === +this.hospital_id
        );
        const { activate_portal, activate_azmoon } = currentHospital;

        this.setState({
          hospitalInfo: currentHospital,
        });

        if (!activate_portal && !activate_azmoon) {
          disableAzmoonAndPortalBtns();
        } else if (!activate_portal) {
          disablePortalBtns();
        } else if (!activate_azmoon) {
          disableAzmoonBtns();
        }
      })
      .catch(() => userActions.failure(userConstants.ERRORS["serverError"]));
  };

  render() {
    const { handleLogout } = this;

    const { currentPage, BtnList, hospitalInfo } = this.state;
    return (
      <div className="container-fluid main-admin">
        <div className="container-fluid px-5">
          <div className="row my-1">
            <Navigation BtnList={BtnList} dispatch={this.dispatch} />
          </div>
          {currentPage === 3 ? (
            <div className="row mt-1 mb-2">
              <div className="col-lg-12">
                <NotifCard text1="لینک ها یا پیوند های زیر به سیستم ها از این صفحه انجام می شود به عنوان مثال می خواهید لینک سامانه غذا را در پرتال نمایش دهید." />
              </div>
            </div>
          ) : (
            ""
          )}
        </div>
        <div className="container-fluid px-5">
          <div className="card bg-white shadow text-center border-0 position-relative">
            <div className="position-absolute logout-btn-bg" />
            <BtnRound
              className="position-absolute logout-btn logout-icon"
              onClick={handleLogout}
            />
            <AdminMessage
              text={`کاربر گرامی  به صفحه ادمین ${hospitalInfo.name} سامانه سنجاب خوش آمدید.`}
            />
          </div>
        </div>
        {currentPage === 0 && <EduAdmin />}
        {currentPage === 1 && <NewsAdmin />}
        {currentPage === 2 && <Events />}
        {currentPage === 3 && <Tools />}
        {currentPage === 4 && <TelCenter />}
        {currentPage === 5 && <GeneralInfo />}
        {currentPage === 6 && <HappyBirthday />}
      </div>
    );
  }
}

class Navigation extends Component {
  render() {
    const { BtnList } = this.props;
    return (
      <div className="col-lg-12 indexSec">
        <div className="border-0 h-100 ">
          <RoundedBtnWrapper>
            {BtnList.map(({ img, text, onClick }, i) => (
              <RoundedBtn
                key={i}
                img={img}
                text={text}
                onClick={() => onClick(i)}
              />
            ))}
          </RoundedBtnWrapper>
        </div>
      </div>
    );
  }
}

class RoundedBtnWrapper extends Component {
  render() {
    return (
      <div
        className="card border-0"
        style={{ borderRadius: "20px", background: "transparent" }}
      >
        <div className="card-body" style={{ height: "200px" }}>
          <div className="d-flex flex-wrap justify-content-center">
            <div className="card-deck">{this.props.children}</div>
          </div>
        </div>
      </div>
    );
  }
}

class RoundedBtn extends Component {
  render() {
    const { img, text, onClick } = this.props;
    return (
      <div
        className="card text-center border-0 "
        style={{ borderRadius: "20px", background: "transparent" }}
      >
        <div
          className="card-body border-0 d-flex"
          style={{ padding: "1.25rem 0" }}
        >
          <a
            className="d-flex flex-column align-items-center indexs btn"
            onClick={onClick}
          >
            <img src={img} alt="" width="75" height="75" />
            <span
              className="iran-sans_Bold text-center text-dark my-2"
              style={{
                width: "100px",
                fontSize: "12px",
                paddingTop: "10px",
              }}
            >
              {text}
            </span>
          </a>
        </div>
      </div>
    );
  }
}

class NotifCard extends Component {
  render() {
    const { text1, text2, color1 = "#777777", color2 = "#6c00ff" } = this.props;

    return (
      <div className="notif py-3 px-5">
        <p style={{ color: color1, margin: 0 }}>{text1}</p>
        {text2 && (
          <p style={{ color: color2, margin: "10px 0 0 0" }}>{text2}</p>
        )}
      </div>
    );
  }
}

const MainAdmin = connect((state) => ({
  globalStorage: state.globalStorage,
}))(MainAdmin_);

export default MainAdmin;
